/**
 * AxLabs Biology Experiments - Generated Exports
 *
 * All generated biology experiments exported as arrays.
 */
// Genetics experiments
export { HardyWeinbergEquilibrium, GeneticDrift, NaturalSelectionDirectional, NaturalSelectionStabilizing, MutationRateEffects, GeneFlowBetweenPopulations, } from './genetics.js';
// Ecology experiments
export { CompetitionLotkaVolterra, PredatorSaturationTypeII, PredatorSwitchingTypeIII, SIREpidemicModel, AgeStructuredPopulation, EnergyFlowTrophicLevels, } from './ecology.js';
// Cell transport experiments
export { FacilitatedDiffusion, ActiveTransportATP, SodiumPotassiumATPase, Chemiosmosis, } from './cell-transport.js';
// ============================================================================
// EXPERIMENT ARRAYS BY CATEGORY
// ============================================================================
import { HardyWeinbergEquilibrium, GeneticDrift, NaturalSelectionDirectional, NaturalSelectionStabilizing, MutationRateEffects, GeneFlowBetweenPopulations, } from './genetics.js';
import { CompetitionLotkaVolterra, PredatorSaturationTypeII, PredatorSwitchingTypeIII, SIREpidemicModel, AgeStructuredPopulation, EnergyFlowTrophicLevels, } from './ecology.js';
import { FacilitatedDiffusion, ActiveTransportATP, SodiumPotassiumATPase, Chemiosmosis, } from './cell-transport.js';
/**
 * All genetics experiments
 */
export const geneticsExperiments = [
    HardyWeinbergEquilibrium,
    GeneticDrift,
    NaturalSelectionDirectional,
    NaturalSelectionStabilizing,
    MutationRateEffects,
    GeneFlowBetweenPopulations,
];
/**
 * All ecology experiments
 */
export const ecologyExperiments = [
    CompetitionLotkaVolterra,
    PredatorSaturationTypeII,
    PredatorSwitchingTypeIII,
    SIREpidemicModel,
    AgeStructuredPopulation,
    EnergyFlowTrophicLevels,
];
/**
 * All cell transport experiments
 */
export const cellTransportExperiments = [
    FacilitatedDiffusion,
    ActiveTransportATP,
    SodiumPotassiumATPase,
    Chemiosmosis,
];
/**
 * All generated biology experiments
 */
export const allBiologyExperiments = [
    ...geneticsExperiments,
    ...ecologyExperiments,
    ...cellTransportExperiments,
];
/**
 * Total count of generated experiments
 */
export const experimentCount = {
    genetics: geneticsExperiments.length,
    ecology: ecologyExperiments.length,
    cellTransport: cellTransportExperiments.length,
    total: allBiologyExperiments.length,
};
//# sourceMappingURL=index.js.map